
export default {
  name: "Tldr",
  props: {
    items: { type: Array, default: () => [] },
  },
};
